<div class="container-box">
  <app-table-header tableTitle="Origine contatto" (btnUpdateClick)="loadContactSource()">
    <app-button-new-contact-source action-button></app-button-new-contact-source>
  </app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="contactSourceTable"
      class="table-content"
      [settings]="settings"
      [source]="source"
    ></ng2-smart-table>
  </div>
</div>
